import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  inputText: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
}
const ExampleSearchForm = (props) => {
  const { inputText, content } = props
  return (
    <styles.ExampleSearchForm>
      <styles.SearchFormInputContainer>
        <styles.SearchFormInput type="text" value={inputText} disabled />
        <styles.SearchIcon />
      </styles.SearchFormInputContainer>
      <styles.SearchFormResultContainer>
        <styles.SearchResultHeader>
          {content.result1HeaderBefore}
          <styles.Keyword>{content.result1HeaderKeyword}</styles.Keyword>
          {content.result1HeaderAfter}
        </styles.SearchResultHeader>
        <styles.SearchResultText>
          {content.result1TextBefore}
          <styles.Keyword>{content.result1TextKeyword}</styles.Keyword>
          {content.result1TextAfter}
        </styles.SearchResultText>
        <styles.SearchResultHeader>
          {content.result2HeaderBefore}
          <styles.Keyword>{content.result2HeaderKeyword}</styles.Keyword>
          {content.result2HeaderAfter}
        </styles.SearchResultHeader>
        <styles.SearchResultText>
          {content.result2TextBefore}
          <styles.Keyword>{content.result2TextKeyword}</styles.Keyword>
          {content.result2TextAfter}
        </styles.SearchResultText>
      </styles.SearchFormResultContainer>
      <styles.ResultNumber>{content.resultNumber}</styles.ResultNumber>
    </styles.ExampleSearchForm>
  )
}

ExampleSearchForm.propTypes = propTypes

export default ExampleSearchForm
